import http from '../http-common';

class TeacherAssignmentService {
  getAll(params) {
    return http.get('/teacher-assignments', { params });
  }

  getFormData() {
    return http.get('/teacher-assignments/form-data');
  }

  create(data) {
    return http.post('/teacher-assignments', data);
  }

  remove(id) {
    return http.delete(`/teacher-assignments/${id}`);
  }
}

export default new TeacherAssignmentService();
